/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
export const REDIRECT_APPS = ["zapier"] as const;
export type RedirectApp = (typeof REDIRECT_APPS)[number];
